import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-status-field',
  templateUrl: './status-field.component.html',
  styleUrls: ['./status-field.component.scss'],
})
export class StatusFieldComponent {
  @Input() form!: FormControl;
  @Output() formChange = new EventEmitter<FormControl>();

  options!: string[];

  constructor() {
    this.options = ['計画', '実施', '中止'];
  }

  onChange(): void {
    this.formChange.emit(this.form);
  }
}
